<script>
import Cookie from '@/common/js/cookie'
import { userApi } from '@/apis'

export default {
    user: null,
    replyInputImageVisible: false,
    get REPLY_INPUT_IMAGE_VISIBLE() {
        const visible = this.replyInputImageVisible
        this.replyInputImageVisible = false
        return visible
    },
    set REPLY_INPUT_IMAGE_VISIBLE(val) {
        this.replyInputImageVisible = val
    },
    get bindedPhone() {
        return Cookie.get('binded_phone') === 'true' || this.user?.phone_number
    },
    updateUser() {
        return new Promise(async (resolve) => {
            try {
                const {body: user} = await userApi.userUidGet({
                    params: {
                        uid: Cookie.get('uid')
                    }
                })
                this.user = user
                Cookie.set('binded_phone', !!(user.phone_number))
                resolve(this.user)
            } catch(err) {
                resolve(null)
            }
        })
    },
    refreshToken() {
        return new Promise(async (resolve) => {
            try {
                const { body: user } = await userApi.refreshTokenPost()
                this.user = user
                Cookie.set('access_token', user.access_token, user.expires_in)
                resolve(this.user)
            } catch(err) {
                resolve()
            }
        })
    }
}
</script>